import AuthGuard from "./layout/AuthGuard";
import DashboardLayout from "./layout/dashboardLayout/DashboardLayout";
import ContactUs from "./pages/contactus/ContactUs";
import DashboardHomePage from "./pages/dashboard/DashboardHomePage";
import MyTicketsPage from "./pages/dashboard/mytickets/MyTicketsPage";
import MyWinningsPage from "./pages/dashboard/mywinnings/MyWinningsPage";
import MyReferralsPage from "./pages/dashboard/referrals/MyReferralsPage";
import MyTransactionsPage from "./pages/dashboard/transactions/MyTransactionsPage";
import DisclaimerPage from "./pages/disclaimer/DisclaimerPage";
import DrawPage from "./pages/draw/Draw";
import DrawDetails from "./pages/draw/drawdetails/DrawDetails";
import Home from "./pages/home/Home";
import LeaderboardPage from "./pages/leaderboard/LeaderboardPage";
import PrivacyPolicyPage from "./pages/privacyPolicy/PrivacyPolicyPage";
import ReferralsPage from "./pages/referrals/ReferralsPage";
import TermsConditionPage from "./pages/termsCondition/TermsConditionPage";
import TestimonialsPage from "./pages/testimonials/TestimonialsPage";

import { metaMaskState } from "./hooks/store";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./layout/MainLayout";
import { useHookstate } from "@hookstate/core";
import AdminLayout from "./layout/adminlayout/AdminLayout";
import AdminsLists from "./pages/admin/admins-list/AdminsLists";
import AdminUsers from "./pages/admin/users/AdminUsers";
import AdminDraws from "./pages/admin/draws/AdminDraws";
import UserDetails from "./pages/admin/users/UserDetails";
import AdminDrawDetails from "./pages/admin/draws/AdminDrawDetails";
import AdminGuard from "./layout/adminlayout/AdminGuard";
import ArticlesList from "./pages/article/ArticlesList";
import ArticleDetail from "./pages/article/ArticleDetail";
import ReferralEarning from "./pages/referal-earning/ReferralEarning";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        { path: "draw", element: <DrawPage /> },
        { path: "draw/:drawId", element: <DrawDetails /> },
        { path: "contact-us", element: <ContactUs /> },
        { path: "testimonials", element: <TestimonialsPage /> },
        { path: "winners", element: <LeaderboardPage /> },
        { path: "privacy-policy", element: <PrivacyPolicyPage /> },
        { path: "terms-condition", element: <TermsConditionPage /> },
        { path: "disclaimer", element: <DisclaimerPage /> },
        { path: "referrals", element: <ReferralsPage /> },
        { path: "articles", element: <ArticlesList /> },
        { path: "articles/:articleId", element: <ArticleDetail /> },
        { path: "referral-earning", element: <ReferralEarning /> },
      ],
    },
    {
      path: "/dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        // { index: true, element: <DashboardHomePage /> },
        { index: true, path: "tickets", element: <MyTicketsPage /> },
        { path: "winnings", element: <MyWinningsPage /> },
        { path: "transactions", element: <MyTransactionsPage /> },
        { path: "referrals", element: <MyReferralsPage /> },
      ],
    },
    {
      path: "/admin",
      element: (
        <AdminGuard>
          <AdminLayout />
        </AdminGuard>
      ),
      children: [
        { index: true, path: "users", element: <AdminUsers /> },
        { path: "draws", element: <AdminDraws /> },
        { path: "admins-list", element: <AdminsLists /> },
        { path: "/admin/draws/:drawId", element: <AdminDrawDetails /> },
        { path: "/admin/users/:fullName", element: <UserDetails /> },
      ],
    },
  ],
  {
    future: {
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true, // Enable the future flag
    },
  }
);

const AppRoutes = () => {
  const metamaskState = useHookstate(metaMaskState);

  useEffect(() => {
    try {
      const storedAddress = Cookies.get("connectedAddress");
      const walletInfoData = localStorage.getItem("connectedWalletInfo");

      if (storedAddress) {
        if (walletInfoData) {
          const walletInfo = JSON.parse(walletInfoData);
          metamaskState.set({
            isConnected: true,
            address: storedAddress,
            walletIcon: walletInfo.walletIcon,
            walletName: walletInfo.walletType,
          });
        }
      }
    } catch (error) {}
  }, []);

  return <RouterProvider router={router} />;
};
export default AppRoutes;
